import React from 'react';

import Row from '@amzn/meridian/row';
import { type RowProps } from '@amzn/meridian/row/row';
import Tag from '@amzn/meridian/tag';

import './appliedFilterTags.scss';

export interface FilterTag<T extends object> {
  prefix: string;
  value: string | number;
  optionName: keyof T;
}

interface AppliedFilterTagsProps<T extends object> extends RowProps {
  filterTags: FilterTag<T>[];
  onDismissTag: (tag: FilterTag<T>) => void;
  'tag-data-testid'?: string;
}

/**
 * Default component
 */
const AppliedFilterTags = <T extends object>({
  filterTags,
  onDismissTag,
  'tag-data-testid': tagDataTestId,
  className = '',
  ...rowProps
}: AppliedFilterTagsProps<T>) => {
  return filterTags.length ? (
    <Row wrap="down" className={`applied-filter-tags ${className}`} {...rowProps}>
      {filterTags.map((filterTag) => (
        <Tag
          onClose={() => onDismissTag(filterTag)}
          type="theme"
          key={`${filterTag.prefix}${filterTag.value}`}
          data-testid={tagDataTestId ?? 'applied-filter-tag'}
        >
          {`${filterTag.prefix}${filterTag.value}`}
        </Tag>
      ))}
    </Row>
  ) : (
    <></>
  );
};

export default AppliedFilterTags;
